<template>
  <div class="block-form">
    <div class="form-field">
      <div class="form-label">Estilo</div>
      <q-btn-toggle
        :model-value="block.style"
        :options="styleOptions"
        unelevated
        dense
        no-caps
        toggle-color="primary"
        @update:model-value="emit('update', { ...block, style: $event })"
      />
    </div>

    <div class="form-label" style="margin-bottom: 4px;">Items</div>
    <div
      v-for="(item, idx) in block.items"
      :key="idx"
      class="item-row"
    >
      <q-input
        outlined
        dense
        :model-value="item"
        :label="`Item ${idx + 1}`"
        style="flex: 1;"
        @update:model-value="updateItem(idx, String($event))"
      />
      <q-btn
        flat
        dense
        round
        icon="delete"
        color="negative"
        @click="removeItem(idx)"
      >
        <q-tooltip>Eliminar item</q-tooltip>
      </q-btn>
    </div>

    <q-btn
      flat
      no-caps
      icon="add"
      label="Agregar item"
      color="primary"
      size="sm"
      @click="addItem"
    />
  </div>
</template>

<script setup lang="ts">
interface ListBlock {
  type: 'list';
  style: 'bullet' | 'numbered';
  items: string[];
}

const props = defineProps<{ block: ListBlock }>();
const emit = defineEmits<{ (e: 'update', block: ListBlock): void }>();

const styleOptions = [
  { label: 'Viñetas', value: 'bullet' },
  { label: 'Numerada', value: 'numbered' },
];

function updateItem(idx: number, value: string) {
  const items = [...props.block.items];
  items[idx] = value;
  emit('update', { ...props.block, items });
}

function removeItem(idx: number) {
  const items = props.block.items.filter((_, i) => i !== idx);
  emit('update', { ...props.block, items });
}

function addItem() {
  emit('update', { ...props.block, items: [...props.block.items, ''] });
}
</script>

<style scoped lang="scss">
.block-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.form-label {
  font-size: 13px;
  color: var(--oa-text-muted);
}
.item-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
